// extracted by mini-css-extract-plugin
export default {"header":"WBhL0exhyk0sHaBygQxY"};